export const getProgressValue = (value = 0) => (value > 100 ? 100 : value);
